<template>
    <div class="">
        <div class="example-problem"  v-if="null_problem_list_show">
            <div class="example-problem-main">
                <h2 style="margin-top: 10%;font-size: 30px;">{{$t('contact_us')}}</h2>
                <p style="margin: 30px 0;">{{$t('faq_service')}}</p>
                <div class="contact_way pcShow" v-for="(item,index) in contace_list" :key="index">
                    <div class="contact_item1">
                        <img :src="item.img" width="40">
                    </div>
                    <div class="contact_item2">
                        <p v-html="item.contact_tile"></p>
                    </div>
                    <div style="clear: both"></div>
                    <div class="contact_item3">
                        <p v-html="item.contact_phone"></p>
                    </div>
                </div>
                <div class="contact_way mobileShow" v-for="(item,index) in contace_list" :key="index">
                    <div class="contact_item1">
                        <img :src="item.img" width="40">
                    </div>
                    <div class="contact_item2">
                        <p v-html="item.contact_tile"></p>
                        <p v-html="item.contact_phone"></p>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
        <div class="example-problem-group"  v-else>
            <h2 class="example-problem-title">
                {{faqlist.now_title}}
            </h2>
            <ul class="Catalog_list">
                <li v-for="(list,index) in faqlist.table_of_contents" :key="index">
                    <a href="javascript:void(0)" @click="jump (index,'list'+index) " v-html="list.title"></a>
                </li>
            </ul>
            <div  class="example-problem" v-for='(item,index,key) in problem_list' :key="index" >
                <div class="example-problem-main" :id="'list'+index">
                    <h2 v-html="item.title">Q:</h2>
                    <p v-html="item.content"></p>
                    <!--<router-link :to="{name:'problemContent',params:{id:item.id}}" class="remain">-->
                        <!--{{$t('Services_mainpage_remain_to_be_solved')}}-->
                        <!--<img class="remain-icon" src="../../assets/fold.png" width="10">-->
                    <!--</router-link>-->
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import Signature from '../../lib/Signature'

    export default {
        name: 'ProblemList',
        data () {
            return {
                problem_list: [],
                problem_type: null,
                limit: 4,
                null_problem_list_show:false,
                faqlist: '',
                contace_list: [
                    {
                        img:require('../../assets/wechat.png'),
                        contact_tile:this.$t('contact_way2'),
                        contact_phone:'IFREEGROUP'
                    },
                    {
                        img:require('../../assets/004-whatsapp.png'),
                        contact_tile:this.$t('faq_whatapp'),
                        contact_phone:'+4474 5204 6699'
                    },
                    {
                        img:require('../../assets/icon50_call.png'),
                        contact_tile:this.$t('faq_website'),
                        contact_phone:'www.ifree.ly/support'
                    }
                ]
            }
        },
        props: {
            services: Array
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },
        created () {
            this.fetchData()
        },
        methods: {

            fetchData () {
                const module = 'index.php/faq/list'
                let data = {}
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.keywords = this.$route.query.keywords || ''
                data.category_id = this.$route.query.category_id
                data.id = this.$route.query.id
                this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    this.problem_list = response.data.data.problem_list
                    this.null_problem_list = response.data.data.problem_list.length
                    this.faqlist = response.data.data
                    if(this.null_problem_list == 0) {
                        this.null_problem_list_show = true
                    }else{
                        this.null_problem_list_show = false
                    }
                }.bind(this))
            },
            jump (index,selector) {
                // 用 class="d_jump" 添加锚点
                let jump = document.querySelectorAll('.example-problem')
                let total = jump[index].offsetTop
                let distance = document.documentElement.scrollTop || document.body.scrollTop
                // 平滑滚动，时长500ms，每10ms一跳，共50跳
                let step = total / 50
                if (total > distance) {
                    smoothDown()
                } else {
                    let newTotal = distance - total
                    step = newTotal / 50
                    smoothUp()
                }
                function smoothDown () {
                    if (distance < total) {
                        distance += step
                        document.body.scrollTop = distance
                        document.documentElement.scrollTop = distance
                        setTimeout(smoothDown, 10)
                    } else {
                        document.body.scrollTop = total
                        document.documentElement.scrollTop = total
                    }
                }
                function smoothUp () {
                    if (distance > total) {
                        distance -= step
                        document.body.scrollTop = distance
                        document.documentElement.scrollTop = distance
                        setTimeout(smoothUp, 10)
                    } else {
                        document.body.scrollTop = total
                        document.documentElement.scrollTop = total
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .example-problem-group .example-problem-title{
        width: 85%;
        margin: 0 auto;
        font-size: 30px;
        font-weight: 500;
    }
    .Catalog_list{
        width: 85%;
        margin: 20px auto;

    }
    .Catalog_list a{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #0084FF;
        line-height: 30px;
    }
    .example-problem {
        width: 90%;
        margin: 0 auto;
        border-bottom: 2px solid #D3DCE6;
    }

    .example-problem-main {
        width: 95%;
        margin: 20px auto;
    }

    .remain {
        font-size: 16px;
        color: #0084FF;
        position: relative;
    }

    .remain-icon {
        position: absolute;
        right: -16px;
        top: -1px;
    }

    .example-problem-main h2 {
        font-size: 24px;
        font-weight: 500;
    }

    .example-problem-main p {
        font-size: 16px;
        color: #5E6D82;
        margin: 10px 0 5px 0;
    }
    .contact_way{
        max-width: 550px;
        display: flex;
        margin: 20px 0;
    }
    .contact_way .contact_item1{
        width: 12%;
    }
    .contact_way .contact_item2{
        width: 35%;
    }
    .contact_way .contact_item3{
        width: 50%;
    }
    .mobileShow{
        display: none !important;
    }

    @media (max-width:414px) {
        .mobileShow{
            display: block !important;
        }
        .pcShow{
            display: none !important;
        }
    }
</style>



// WEBPACK FOOTER //
// ProblemList.vue?4a05b18a